'use client';
import { useSearch } from '@/hooks/useSearch';

import CachedOutlined from '@mui/icons-material/CachedOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import style from './style.module.css';

interface SearchInputProps {
  placeholder?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({ placeholder }) => {
  const { handleSearch, searchParamsValue, searchLoading } = useSearch('name');
  const [value, setValue] = useState(searchParamsValue);
  // const [loading, setLoading] = useState(false);
  const onValueChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      // setLoading(!!event.target.value);
      setValue(event.target.value);
      handleSearch(event.target.value);
    },
    [setValue, handleSearch]
  );

  useEffect(() => {
    if (searchParamsValue) {
      setValue(searchParamsValue);
    }
    // setLoading(false);
  }, [searchParamsValue]);

  return (
    <div className={style.containerSearchInput}>
      <div className={style.contentSearchInput}>
        {searchLoading ? (
          <CachedOutlined
            className={`${style.iconSearchInput} ${style.spinner}`}
          />
        ) : (
          <SearchOutlinedIcon className={style.iconSearchInput} />
        )}
        <input
          placeholder={placeholder}
          className={style.searchInputUtua}
          onChange={onValueChange}
          value={value}
        />
      </div>
    </div>
  );
};

export default SearchInput;
